import { render, staticRenderFns } from "./InfoBudget.vue?vue&type=template&id=4d0600ef"
import script from "./InfoBudget.vue?vue&type=script&lang=js"
export * from "./InfoBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports